import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';

const OAuthCallback = () => {
    const navigate = useNavigate();
    const [error, setError] = useState('');
    
    useEffect(() => {
        try {
            // Process OAuth callback data from URL
            const processed = authService.processOAuthCallback();
            
            if (processed) {
                // If successfully processed, redirect to members page
                navigate('/members');
            } else {
                // If no valid OAuth data in URL, show error
                setError('Invalid authentication data received');
                setTimeout(() => navigate('/login'), 3000);
            }
        } catch (err) {
            console.error('Error processing OAuth callback:', err);
            setError('Authentication failed');
            setTimeout(() => navigate('/login'), 3000);
        }
    }, [navigate]);
    
    return (
        <div className="oauth-callback-container">
            <h2>Completing Authentication...</h2>
            {error ? (
                <p className="error">{error}</p>
            ) : (
                <p>You will be redirected shortly, please wait...</p>
            )}
        </div>
    );
};

export default OAuthCallback;
